/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {Grid, Button} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import loadImage from "../../loader.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";

import PopUpComponent from "../../components/Nav/PopUpComponent";
import PhotosComponent from "../../components/Photo/PhotosComponent"; // eslint-disable-line
import {useThemeData} from '../../context/ThemeDataContext'
import GeneralButton from "../Buttons";
import {usePhotoBaseData} from "../../context/PhotoBasicDataContext";

function PhotoFilterComponent(props) {
    const {site_id} = useThemeData().themeData.site;
    const { background_color_5, font_family_button} = useThemeData().themeData.site.theme;
    const { hide_category_side_bar  } = useThemeData().modules;
    const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
    const PRODUCT_URL = process.env.REACT_APP_PRODUCT_URL;
    const APP_URL = process.env.REACT_APP_SITE_URL
    const [message, setMessage] = useState(false)
    const [zoom, setZoom] = useState(false)
    const [photo_id, setPhotoID] = useState()
    const [folder_id, setFolderID] = useState(props.folder_id)
    const [photo_file_name, setPhotoFileName] = useState(props.photo_file_name)
    const [file_changed, setFileChanged] = useState(false)
    const [product_color, setProductColor] = useState(props.product_color)
    const props_photos = usePhotoBaseData().photoData;

    let combivel_id = 0;
    if (props.combivel_id === null) {
        combivel_id = 0;
    } else {
        combivel_id = props.combivel_id;
    }

    let effect_file_id = 0;
    if (props.effect_file_id === null) {
        effect_file_id = 0;
    } else {
        effect_file_id = props.effect_file_id;
    }

/*
    let effect_file_id_for = 0;
    if (props.effect_file_id_for === null) {
        effect_file_id_for = 0;
    } else {
        effect_file_id_for = props.effect_file_id_for;
    }
*/


    function isObject(val) {
        if (val === null) {
            return false;
        }
        return ((typeof val === 'function') || (typeof val === 'object'));
    }

    function hasMultiplePhotos(data, type) {
        let photoCount = 0;

        for (const item of data) {
            // Match type for both 'groep' (group) and 'portret' (portrait)
            if (
                (type === 'groep' && (item.type === 'groep' || item.type === 'groepsfoto download')) ||
                (type === 'portret' && item.type !== 'groep' && item.type !== 'groepsfoto download')
            ) {
                photoCount++;
            }
        }
        // Return true only if there are 2 or more photos of the specified type
        return photoCount >= 2;
    }

    function RenderButtonOrSpace({ pakket_selectie, child_product_type, product_type, t, photos }) {
        const isGroupPhoto = child_product_type === 'groepsfoto' || child_product_type === 'groepsfoto download';
        const isPortraitPhoto = !isGroupPhoto; // Everything else is considered a portrait photo
        const isPakketNotProductOrDivers = product_type === 'pakket' && child_product_type !== 'product' && child_product_type !== 'divers';
        const shouldShowButton = pakket_selectie !== 'nee';
        if (isGroupPhoto && isPakketNotProductOrDivers) {
            const photoType = 'groep';
            if (hasMultiplePhotos(photos, photoType)) {
                return (
                    <GeneralButton
                        className="btn btn-light btn-layout hide--start-icon"
                        style={{ fontSize: '9px', padding: '2px', width: hide_category_side_bar === 'true' ? '40%' : 'auto' }}
                        startIcon={<ArrowRightIcon />}
                        onClick={() => setMessage(!message)}
                    >
                        {child_product_type !== 'download' ? t('Select photo') : t('Select download')}
                    </GeneralButton>
                );
            }
            return <div style={{ height: '25px' }}></div>;
        }

        if (isPortraitPhoto && isPakketNotProductOrDivers && shouldShowButton) {
            const photoType = 'portret';
            if (hasMultiplePhotos(photos, photoType)) {
                return (
                    <GeneralButton
                        className="btn btn-light btn-layout hide--start-icon"
                        style={{ fontSize: '9px', padding: '2px', width: hide_category_side_bar === 'true' ? '40%' : 'auto' }}
                        startIcon={<ArrowRightIcon />}
                        onClick={() => setMessage(!message)}
                    >
                        {child_product_type !== 'download' ? t('Select photo') : t('Select download')}
                    </GeneralButton>
                );
            }
            return <div style={{ height: '25px' }}></div>;
        }

        // Show button for non-group and non-portrait products
        if (shouldShowButton && isPakketNotProductOrDivers) {
            return (
                <GeneralButton
                    className="btn btn-light btn-layout hide--start-icon"
                    style={{ fontSize: '9px', padding: '2px', width: hide_category_side_bar === 'true' ? '40%' : 'auto' }}
                    startIcon={<ArrowRightIcon />}
                    onClick={() => setMessage(!message)}
                >
                    {child_product_type !== 'download' ? t('Select photo') : t('Select download')}
                </GeneralButton>
            );
        }

        // Render empty space if the button shouldn't be shown
        if (shouldShowButton) {
            return <div style={{ height: '25px' }}></div>;
        }

        return null;
    }


    useEffect(() => {
        let newName = props.product_color
        if(props.product_color===''){
            setProductColor('Kleur')
        }else {
            if (product_color !== newName) {
                setProductColor(newName)
            }
        }
    }, [props.product_color, product_color])

    // package photos change accordingly when clicked on next/previous when using this code below:
    // but not using it will make sure you can change a package photo by clicking on it.
    useEffect(() => {

        let newName = props.photo_file_name
        if (photo_id === undefined && file_changed === false) {
            setPhotoFileName(newName)
        }

    }, [props.photo_file_name, file_changed, props.photo_id, photo_id])

    useEffect(() => {
        let newName = props.file_changed
        if (file_changed !== newName) {
            setFileChanged(newName)
        }

    }, [props.file_changed, file_changed])

    // function colorSwitch(color) {
    //     switch (color) {
    //         case 'Sepia':
    //             return 'sepia';
    //         case 'Zwart-wit':
    //             return 'grayscale';
    //         default:
    //             return [
    //                 1, 0, 0, 0, 0,
    //                 0, 1, 0, 0, 0,
    //                 0, 0, 1, 0, 0,
    //                 0, 0, 0, 1, 0,
    //             ]; // is no filter
    //     }
    // }


    //console.log(product_color);

    const closePopupZoom = () => {
        setZoom(false);
    }

    const closePopup = (photofile_name, photoid, i, folder_id) => {
        setMessage(false);
        if (photofile_name && photoid) {
            const regNumber = new RegExp(`^-?[0-9]+$`);
            if (regNumber.test(props.product_combivel_id)) { //combivel

                if (isObject(photofile_name) !== true) {
                    var fileExt = photofile_name.replace(/(\.[^/.]+)+$/, "");
                    var fileType = photofile_name.split('.').pop();
                    var FileName = `${photoid}_${fileExt}_${props.product_combivel_id}.${fileType}`;
                    if (FileName !== null) {
                        setFolderID(folder_id);
                        setPhotoID(photoid);
                        setPhotoFileName(photofile_name);
                        setFileChanged(!file_changed);
                        props.updatePhotoFileName(photofile_name, props.product_id, props.product_child_id, photoid, props.Index, folder_id);
                    }
                }
            } else { //normal photo
                const newFile = photofile_name;

                if (isObject(newFile) !== true) {
                    setPhotoID(photoid);
                    setPhotoFileName(newFile);
                    setFolderID(folder_id);
                    setFileChanged(!file_changed);
                    // console.log(props.Index);
                    props.updatePhotoFileName(newFile, props.product_id, props.product_child_id, photoid, props.Index, i, folder_id);
                }
            }
        }
    }

    let effectFileIdFor =0;
    if (props.product_type === 'groepsfoto' || props.product_type === 'groepsfoto download') {
        effectFileIdFor = 0;
    }else{
        effectFileIdFor = props.effect_file_id_for;
    }

    // if (props.photoservice === true) {
    //     return (
    //         <>
    //             <ImageFilter
    //                 className={`${props.className}`}
    //                 image={props.image}
    //                 filter={colorSwitch(props.color)}
    //                 onClick={props.onClick}
    //             />
    //         </>
    //     )
    // }

    // photoUploadComponent
    // if (props.uploadType === true) {
    //     return (
    //         <>
    //             <ImageFilter
    //                 className="image-size"
    //                 image={props.image}
    //                 filter={colorSwitch(product_color)}
    //             />
    //         </>
    //     )
    // }
    if (props.photoType === 1) {
        // photo in pakket or with filter in shoppingcart
        return (
            <>
                <div className="photoBox derde">
                    <div style={{float: "left"}}>
                        <LazyLoadImage
                            className="photo_filter_shoppingcart"
                            src={`${PHOTO_URL}${site_id}/${props.folder_id}/${combivel_id}/${effect_file_id}/${effectFileIdFor}/${product_color}/${props.photo_id}/${props.photo_file_name}`}
                            alt={props.photo_file_name}
                            style={{border: `1px solid ${background_color_5}`, maxWidth: "100%"}}
                            placeholderSrc={loadImage}
                        />
                    </div>
                </div>
            </>
        )
    } else {
        // photo with filter in shoppage

        const colors = props.product_child_colors !== null && props.product_child_colors !== '' && props.product_child_colors !== undefined ? props.product_child_colors.split(";") : null;
       // let color = 'Kleur';
        if(colors !== null) {
            if(colors.length === 1){
               // color = colors[0];
            } else {
                //color = 'Kleur';
            }
        }

        //console.log(colors);

        let effectFileIdFor =0;
        if (props.child_product_type === 'groepsfoto' || props.child_product_type === 'groepsfoto download') {
            effectFileIdFor = 0;
        }else{
            effectFileIdFor = props.effect_file_id_for;
        }


        //console.log(props);

        return (
            <>

                <div
                    style={{
                        width: `100%`,
                        display: `inline-block`,
                    }}
                    className="text-center"
                    onClick={props.type === 'extra_products' || props.type === 'photoservice' ? null : () => setZoom(!zoom)}>
                    {(file_changed !== props.file_changed || props.file_changed === undefined) && props.product_combivel_id !== null && props.product_combivel_id !== undefined ?
                        <>
                            <div className="photoBox">
                                <LazyLoadImage
                                    className="photo_filter_shoppage img-sizing"
                                    style={{
                                        backgroundImage: `url(${props.effect_file_name}`,
                                        border: `1px solid ${background_color_5}`
                                    }}
                                    src={`${PHOTO_URL}${site_id}/${props.folder_id}/${props.product_combivel_id}/${props.effect_id}/${effectFileIdFor}/${product_color}/${props.photo_id}/${photo_file_name}`}
                                    alt={props.photo_file_name}
                                    placeholderSrc={loadImage}
                                />
                            </div>
                        </>
                        :
                        (file_changed !== props.file_changed || props.file_changed === undefined) && props.product_combivel_id === null ?
                            <>
                                <div className="photoBox">
                                    {props.product_type === 'product' && props.product_image !== null && props.product_image !== undefined &&
                                        <img
                                            // src={`${PHOTO_URL}${site_id}/${props.folder_id}/${props.product_combivel_id}/0/${props.photo_id}/${props.product_image}`}
                                            src={`${APP_URL}${site_id}/${props.product_image}`}
                                            alt={props.product_image}
                                            className="img-sizing product_afbeelding"
                                        />
                                    }
                                    <LazyLoadImage
                                        src={`${PHOTO_URL}${site_id}/${props.folder_id}/0/0/0/${product_color}/${photo_id}/${photo_file_name}`}
                                        alt={photo_file_name}
                                        className="photo_filter_shoppage image-sizing img-sizing product_photo"
                                        placeholderSrc={loadImage}
                                        style={{border: `1px solid ${background_color_5}`}}
                                    />
                                </div>
                            </>
                            :
                            <>
                                {
                                    /* photos in shop. pakketten, combi's and normal */
                                    // console.log(props)
                                }
                                <div
                                    className={`${props.product_type === 'pakket' || props.type === 'photoservice' || props.type === 'extra_products' ? 'photoBoxPakket' : 'photoBox'}`}>
                                    {props.product_combivel_id != null ?
                                        <>
                                            <LazyLoadImage
                                                src={`${PHOTO_URL}${site_id}/${folder_id}/${props.product_combivel_id}/${props.effect_id}/${effectFileIdFor}/${product_color}/${props.photo_id}/${photo_file_name}`}
                                                alt={photo_file_name}
                                                className="photo_filter_shoppage image-sizing 8"
                                                style={{
                                                    border: `1px solid ${background_color_5}`,
                                                    alignItems: `top`,
                                                    cursor: 'zoom-in',
                                                }}
                                                placeholderSrc={loadImage}
                                            />
                                        </>
                                        :
                                        props.type === 'extra_products' || props.type === 'photoservice' ?
                                            <Button
                                                style={{
                                                    float: 'center',
                                                    fontFamily: `${font_family_button}`,
                                                }}
                                                className="extra_products image-link"
                                                onClick={() => setMessage(!message)}>
                                                <Grid item xs={12} sm={12} md={12} className="no-padding-sides">
                                                    <img
                                                        src={`${PHOTO_URL}${site_id}/${props.folder_id}/0/0/0/0/${props.photo_id}/${photo_file_name}`}
                                                        alt={props.child_product_file}
                                                        className="img-sizing product_afbeelding"
                                                    />
                                                    <GeneralButton
                                                        className="btn btn-light btn-layout hide--start-icon"
                                                        style={{ fontSize: '9px', padding: '2px' }}
                                                        startIcon={<ArrowRightIcon/>}
                                                        onClick={() => setMessage(!message)}>
                                                        {props.child_product_type !== 'download' ? (
                                                            <>{props.t('Select photo')}</>
                                                        ) : (
                                                            <>{props.t('Select download')}</>
                                                        )}

                                                    </GeneralButton>
                                                </Grid>
                                            </Button>
                                            : // pakket photo & normal
                                            <>
                                                {props.product_type === 'product' && props.product_image !== null && props.product_image !== undefined &&
                                                    <LazyLoadImage
                                                    src={`${APP_URL}${site_id}/${props.product_image}`}
                                                    alt={props.product_image}
                                                    className="img-sizing product_afbeelding"
                                                    placeholderSrc={loadImage}
                                                    style={{ height: 'auto', paddingTop: '0px', maxWidth: '100%'  }}
                                                    />
                                                }
                                                {props.child_product_type === 'product' || props.child_product_type === 'divers' ? (
                                                        <LazyLoadImage
                                                          src={`${PRODUCT_URL}${site_id}/${props.photo_id}/${props.product_child_id}/${props.child_product_file}`}
                                                            alt={props.child_product_file}
                                                            className="img-sizing product_afbeelding"
                                                            placeholderSrc={loadImage}
                                                            style={{ height: 'auto', paddingTop: '0px', maxWidth: '100%'  }}
                                                        />
                                                ) : (<LazyLoadImage src={`${PHOTO_URL}${site_id}/${folder_id}/0/${props.effect_id}/${effectFileIdFor}/0/${props.photo_id}/${photo_file_name}`}
                                                alt={props.photo_file_name}
                                                className="photo_filter_shoppage image-sizing 8"
                                                style={{
                                                    border: `1px solid ${background_color_5}`,
                                                    alignItems: `top`,
                                                    cursor: 'zoom-in',
                                                }}
                                                placeholderSrc={loadImage}
                                            />)
                                                }
                                            </>

                                    }
                                </div>
                            </>
                    }
                </div>
                {/*dit is voor het popupje van het vergroten van de foto*/}
                {
                    zoom ?
                        <PopUpComponent
                            content={<>
                                <div className="photoBoxPopUp">
                                    <LazyLoadImage src={`${PHOTO_URL}${site_id}/${props.folder_id}/${props.product_combivel_id}/${props.effect_id}/${effectFileIdFor}/${product_color}/${props.photo_id}/${photo_file_name}`}
                                                   alt={props.photo_file_name}
                                                   className="photo_filter_shoppage image-sizing"
                                                   style={{border: `1px solid ${background_color_5}`}}
                                                   placeholderSrc={loadImage}
                                    />
                                </div>
                            </>}
                            btn2={props.t('Go back')}
                            closePopup={closePopupZoom}
                        />
                        : null
                }
                <RenderButtonOrSpace
                    pakket_selectie={props.pakket_selectie}
                    child_product_type={props.child_product_type}
                    product_type={props.product_type}
                    t={props.t}
                    photos={props_photos}
                />
                {/*einde dit is voor het popupje van het vergroten van de foto*/
                }
                {

                    message ?
                        <PopUpComponent
                            text={<Alert severity="info">{props.t('Select photo')}</Alert>}
                            content={
                                <>
                                    <p>{props.t('Select the photo you would like to have in your package.')}</p>
                                    <PhotosComponent
                                        groepsfoto={props.groepsfoto}
                                        product_child_id={props.product_child_id}
                                        product_id={props.product_id}
                                        product_child_formaat={props.product_child_formaat}
                                        product_child_colors={props.product_child_colors}
                                        style={{backgroundImage: `url(${props.effect_file_name}`,}}
                                        pakket_selectie_alle_inlogs={props.pakket_selectie_alle_inlogs}
                                        productdetailType={1}
                                        login_name={props.login_name}
                                        class_id={props.class_id}
                                        photo_id={props.photo_id}
                                        closePopup={closePopup}
                                    />
                                </>
                            }
                            // btn11={props.t('cart')}
                            // href='/cart'
                            btn2={props.t('Go back')}
                            closePopup={closePopup}
                        />
                        : null
                }
            </>
        );

    }
}

export default React.memo(withTranslation('productdetailComponent')(PhotoFilterComponent));
